import { DefaultSocials } from '@app/core/models/default-socials';
import { ErrorTextsDisplayed } from '@app/core/models/root-error-page';
import { CountryConsents } from '@app/core/models/specific-country-consents';

import { z } from 'zod';

export const FeatureSchema = z.object({
  countryConsents: z.custom<CountryConsents>(),

  handleDisplayedTextInErrorPage: z.custom<ErrorTextsDisplayed>(),

  hideContactSupport: z.array(z.string()),

  excludedFromSocials: z.object({
    countries: z.array(z.string()),
    languages: z.array(z.string()),
  }),
  excludedDefaultSocials: z.array(z.custom<DefaultSocials>()).optional(),
});

export type Feature = z.infer<typeof FeatureSchema>;
